import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import EN from "./en.json";
import ZH from "./zh.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: EN },
      zh: { translation: ZH },
    },
    lng: localStorage.getItem("lang") || "en", // 默认语言
    fallbackLng: "en", // 备用语言
    interpolation: {
      escapeValue: false, // React 已经默认转义
    },
  });

export default i18n;
